$(document).ready(function () {
  // Función para manejar exclusive store tags
  function initExclusiveStoreTags() {
    // console.log('🏪 Initializing exclusive store tags...');

    const exclusiveTagSections = document.querySelectorAll('[data-exclusive-tag-section]');

    // console.log(exclusiveTagSections.length, 'exclusive tag sections found');

    if (exclusiveTagSections.length === 0) {
      // console.log('📝 No exclusive tag sections found');
      return;
    }

    // console.log(`📋 Found ${exclusiveTagSections.length} exclusive tag sections`);

    // Function to get current store (same logic as pickup-availability)
    function getCurrentStore() {
      // First check if customer is logged in and has favorite store in metafields
      const customerFavoriteStore = document.querySelector('[data-customer-favorite-store]');
      if (customerFavoriteStore) {
        const favoriteStore = customerFavoriteStore.getAttribute('data-customer-favorite-store');
        if (favoriteStore && favoriteStore !== 'null' && favoriteStore !== '') {
          // console.log('� Using customer favorite store from metafields:', favoriteStore);
          return favoriteStore;
        }
      }

      // If no customer favorite, check localStorage
      const localStorageStore = localStorage.getItem('favorite_store');
      if (localStorageStore && localStorageStore !== 'null') {
        // console.log('💾 Using store from localStorage:', localStorageStore);
        return localStorageStore;
      }

      // Fallback to first available store
      const firstSection = exclusiveTagSections[0];
      if (firstSection) {
        const currentStore = firstSection.getAttribute('data-current-store');
        // console.log('🔄 Using fallback current store:', currentStore);
        return currentStore;
      }

      return null;
    }

    // Function to update exclusive tags based on current store
    function updateExclusiveTagsDisplay(newStoreNickname) {
      // console.log(`🔄 Updating exclusive tags for store: ${newStoreNickname}`);

      exclusiveTagSections.forEach(section => {
        // Update section's current store
        section.setAttribute('data-current-store', newStoreNickname);

        // Get all store tag elements in this section
        const storeTagElements = section.querySelectorAll('[data-store-exclusive-tag]');

        // Hide all tags first
        storeTagElements.forEach(tagElement => {
          tagElement.style.display = 'none';
        });

        // Show only the tag for the selected store if available
        storeTagElements.forEach(tagElement => {
          const tagStore = tagElement.getAttribute('data-store-exclusive-tag');
          const isAvailable = tagElement.getAttribute('data-store-available') === 'true';

          if (tagStore === newStoreNickname && isAvailable) {
            tagElement.style.display = 'inline-block';
            // console.log(`✅ Showing exclusive tag for store: ${tagStore}`);
          }
        });
      });
    }

    // Initialize with current store
    const currentStore = getCurrentStore();
    if (currentStore) {
      updateExclusiveTagsDisplay(currentStore);
    }

    // Listen for store change events from stores-modal
    document.addEventListener('store:changed', function (event) {
      // console.log('🏪 Store changed event received in exclusive tags:', event.detail);

      if (event.detail && event.detail.storeName) {
        updateExclusiveTagsDisplay(event.detail.storeName);
      }
    });

    // Also listen for localStorage changes (for cross-tab sync)
    window.addEventListener('storage', function (e) {
      if (e.key === 'favorite_store' && e.newValue) {
        // console.log('💾 LocalStorage favorite_store changed:', e.newValue);
        updateExclusiveTagsDisplay(e.newValue);
      }
    });

    // console.log('✅ Exclusive store tags initialized');
  }

  function waitForExclusiveSectionsAndInit() {
    const processedSet = new WeakSet();

    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;

          // Si el nodo agregado es o contiene un .exclusive-store-tags
          if (node.matches?.('.exclusive-store-tags') || node.querySelector?.('.exclusive-store-tags')) {
            const targets = node.matches?.('.exclusive-store-tags')
              ? [node]
              : node.querySelectorAll('.exclusive-store-tags');

            targets.forEach(el => {
              if (!processedSet.has(el)) {
                processedSet.add(el);
                initExclusiveStoreTags(el); // Puedes pasarle el nodo si necesitas inicializarlo por separado
              }
            });
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Por seguridad, corta a los 30s
    setTimeout(() => observer.disconnect(), 30000);
  }


  // Validar si el dispositivo soporta hover
  if (window.matchMedia('(hover: hover)').matches) {
    $('body').addClass('hover-supported'); // El dispositivo soporta hover
  } else {
    $('body').addClass('not-hover-supported');
    $('body').removeClass('hover-supported'); // El dispositivo NO soporta hover
  }
  if ($('body').hasClass('hover-supported')) {
    // console.log('El dispositivo soporta hover.');
  } else {
    // console.log('El dispositivo no soporta hover.');
  }












  // - - - - - - INICIO CODIGO SLICK DOTS ROTATIVOS - - - -   
  // Inicializa el slider CON dots nativos
  const $slider2 = $('.slick-cards');

  const opcionesSliderCards = {
    // Lazy propio de Slick: sólo carga las imágenes de los slides visibles y el
    // siguiente. El loading="lazy" del navegador no vale en carruseles porque mide
    // distancia vertical y se traga la fila entera aunque esté fuera de pantalla.
    lazyLoad: 'ondemand',
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  // Al iniciar, envolvemos los dots en el contenedor con scroll.
  // Se engancha ANTES de inicializar para que el evento 'init' llegue a dispararse.
  $slider2.on('init', function () {
    const $dots = $(this).find('.slick-dots');
    if ($dots.length && !$dots.parent().hasClass('dots-wrapper-scroll')) {
      $dots.wrap('<div class="dots-wrapper-scroll"></div>');
    }
  });

  // Cada carrusel se inicializa sólo cuando se acerca al viewport. Slick no sabe en qué
  // posición de la página está el carrusel: si se inicializan los cuatro a la vez en el
  // load, cada uno carga sus primeros slides aunque esté a 3.000px por debajo del
  // pliegue. Con esto, un slider que está al final no pide ni una imagen hasta que bajas.
  function iniciarSliderCards(el) {
    const $el = $(el);
    if ($el.hasClass('slick-initialized')) return;
    $el.slick(opcionesSliderCards);
  }

  if ('IntersectionObserver' in window) {
    const observadorCards = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        observadorCards.unobserve(entrada.target);
        iniciarSliderCards(entrada.target);
      });
    }, { rootMargin: '600px 0px' });
    $slider2.each(function () { observadorCards.observe(this); });
  } else {
    $slider2.each(function () { iniciarSliderCards(this); });
  }

  // Si el slider ya se inicializó antes de este .on('init')
  if ($slider2.hasClass('slick-initialized')) {
    const $dots = $slider2.find('.slick-dots');
    if ($dots.length && !$dots.parent().hasClass('dots-wrapper-scroll')) {
      $dots.wrap('<div class="dots-wrapper-scroll"></div>');
    }
  }

  // Mantener el activo siempre visible, centrado dentro del contenedor
  $slider2.on('afterChange', function () {
    const $wrap = $(this).find('.dots-wrapper-scroll');
    const $active = $(this).find('.slick-dots li.slick-active')[0];
    if ($wrap.length && $active) {
      $active.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  });

  // - - - - - - FIN CODIGO SLICK DOTS ROTATIVOS - - - -   














  //Slider home tiendas
  $('.slider-stores').slick({
    dots: true,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    infinite: false,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
          dots: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  // $('.slick-cards').slick({
  //   dots: true,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   dots: true,
  //   arrows: true,
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1,
  //         dots: true
  //       }
  //     },
  //     {
  //       breakpoint: 767,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ]
  // });

  const $slider = $('.slick-cards-3');
  const slideCount = $slider.children().length;

  function initSlick() {
    // Destruye si ya está iniciado
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    // Si hay más de 3, activar siempre
    if (slideCount > 3) {
      $slider.slick({
        dots: !(window.innerWidth <= 1024 && slideCount > 6),
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        infinite: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: slideCount <= 6
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false,
              dots: slideCount <= 6
            }
          }
        ]
      });
    } else {
      // Si hay 3 o menos, solo activar Slick en mobile
      if (window.innerWidth < 1025) {
        $slider.slick({
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          infinite: false
        });
      } else {
        // En desktop, sin slick
        $slider.addClass('no-slick');
      }
    }
  }

  // Ejecutar al cargar y al cambiar tamaño
  $(document).ready(initSlick);

  // Sólo se reinicializa si cambia el ANCHO. En móvil, al hacer scroll el navegador
  // oculta la barra de direcciones: eso cambia la altura del viewport y dispara un
  // 'resize'. Como initSlick() hace unslick + init, el slider se destruía y se
  // reconstruía a mitad de scroll -> parpadeo visible y todas las imágenes de los
  // slides clonados se volvían a pedir. Los breakpoints sólo dependen del ancho.
  let anchoPrevio = window.innerWidth;
  $(window).on('resize', function () {
    if (window.innerWidth === anchoPrevio) return;
    anchoPrevio = window.innerWidth;
    clearTimeout(window._slickResizeTimeout);
    window._slickResizeTimeout = setTimeout(initSlick, 300);
  });


  // Inicializar slider solo si existe el elemento
  if ($('.slick-cards-4').length && !$('.slick-cards-4').hasClass('slick-initialized')) {
    $('.slick-cards-4').slick({
      dots: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  // paginas de contenido - servicios - anchors
  var nav = $('.content-pages.content-anchors');

  // Get all sections that have IDs matching the anchor hrefs
  var sections = nav.find('a').map(function () {
    var href = $(this).attr('href');
    if (href && href.startsWith('#')) {
      var targetId = href.substring(1);
      var targetSection = $('section#' + targetId);
      return targetSection[0];
    }
  }).get().filter(Boolean);

  sections = $(sections);

  $(window).on('scroll', function () {
    var cur_pos = $(this).scrollTop();
    var nav_height = nav.outerHeight() || 0;

    sections.each(function () {
      var top = $(this).offset().top - nav_height - 128,
        bottom = top + $(this).outerHeight();

      if (cur_pos >= top && cur_pos <= bottom) {
        nav.find('a').removeClass('active');
        sections.removeClass('active');

        $(this).addClass('active');
        nav.find('a[href="#' + $(this).attr('id') + '"]').addClass('active');
      }
    });
  });

  nav.find('a').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $el = $(this);
    var id = $el.attr('href');
    var $target = $(id);

    if ($target.length > 0) {
      var nav_height = nav.outerHeight() || 0;
      var targetOffset = $target.offset().top - nav_height - 128;

      $('html, body').animate({
        scrollTop: targetOffset
      }, 500);
    }

    return false;
  });



  // Mostrar (poner clase active) a los popups
  $(".click-to-open-popup").click(function () {
    popup = $(this).data("popup")
    $("." + popup).addClass("active")
  })

  // Cerrar popups padre
  $(".close-this-section").click(function () {
    $(this).closest('section').removeClass("active");
  })


  // Custom bikes - tabs
  $(".your-custom-journey .content-items .item").click(function () {
    element = $(this).data("element")
    console.log(element)
    $(".content-items .item").removeClass("active")
    $(this).addClass("active")
    $(".content-info .info").removeClass("active")
    $(".content-info .info[data-element='" + element + "']").addClass("active")
  })

  $('.your-custom-journey .accordion-head').click(function () {
    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      $(this).siblings(".accordion-body").removeClass('open');
      $(this).siblings(".accordion-body").find('.accordion-body').removeClass('open');
    } else {
      $(this).parents('.content-info').find('.accordion-head').removeClass('open')
      $(this).parent().parent().siblings(".accordion-head").addClass("open");
      $(this).addClass("open");
      $(this).siblings(".accordion-body").addClass('open');
      $(this).parent().nextAll().find('.accordion-body').removeClass('open');
      $(this).parent().prevAll().find('.accordion-body').removeClass('open');
    }
  });

  // Página producto
  $('.main-product .content-slider')
    .on('init', function () {
      // Cuando Slick termine de inicializar:
      $('.content-slider-skeleton').hide();
      $(this).css('visibility', 'visible');
    })
    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      infinite: false,
      fade: true,
      asNavFor: '.main-product .content-nav-slider',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            draggable: false,
            swipe: false,
            touchMove: false,
            swipeToSlide: false,
          }
        }
      ]
    });
  $('.main-product .content-nav-slider').slick({
    slidesToShow: 1,
    asNavFor: '.main-product .content-slider',
    dots: false,
    arrows: false,
    infinite: false,
    focusOnSelect: true,
  });
  //poner fixed al slider y redimensionar
  $('.slide-ctas-zoom').on('click', function () {
    $(".main-product .container-slider").addClass("fullScreen")
    //redimensionar slider
    const slider = $('.main-product .content-slider'); // Asegúrate de tener el selector correcto para tu slider
    setTimeout(function () {
      slider.slick('setPosition');
    }, 1);
  })
  //quitar fixed al slider y redimensionar
  $('.remove-fullScreen-slider').on('click', function () {
    $(".main-product .container-slider").removeClass("fullScreen")
    //redimensionar slider
    const slider = $('.main-product .content-slider'); // Asegúrate de tener el selector correcto para tu slider
    setTimeout(function () {
      slider.slick('setPosition');
    }, 1);
  })


  // Página políticas
  var sections = $('.custom-policy-section .content-sections .section')
    , nav = $('.custom-policy-section .content-nav')
    , nav_height = nav.outerHeight();

  $(window).on('scroll', function () {
    var cur_pos = $(this).scrollTop();

    sections.each(function () {
      var top = $(this).offset().top,
        bottom = top + $(this).outerHeight();

      if (cur_pos >= top && cur_pos <= bottom) {
        nav.find('a').removeClass('active');
        sections.removeClass('active');

        $(this).addClass('active');
        nav.find('a[href="#' + $(this).attr('id') + '"]').addClass('active');
      }
    });
  });

  nav.find('a').on('click', function () {
    var $el = $(this)
      , id = $el.attr('href');

    $('html, body').animate({
      scrollTop: $(id).offset().top
    }, 500);

    return false;
  });



  $('.container-happy-customers .content-slider').slick({
    dots: true,
    arrows: true,
    infinite: true,
    variableWidth: true,
  });




  $('.custom-reviews .content-reviews').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 99999,
        settings: "unslick"
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
        }
      },
    ]
  });


  $('.container-reviews .content-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick"
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
          infinite: false,
        }
      },
    ]
  });



  $('.content-included-notincluded').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick"
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
          infinite: false,
        }
      },
    ]
  });


  $('.custom-financing-section.container-slider .content-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 99999,
        settings: "unslick"
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: true,
        }
      },
    ]
  });

  // Slider home - lee configuración desde data-attributes
  $('.custom-video-hero .main-container-slider').each(function () {
    const $el = $(this);
    const dots = String($el.data('dots')).toLowerCase() === 'true' || $el.data('dots') === true;
    const arrows = String($el.data('arrows')).toLowerCase() === 'true' || $el.data('arrows') === true;
    const autoplay = String($el.data('autoplay')).toLowerCase() === 'true' || $el.data('autoplay') === true;
    const autoplaySpeed = parseInt($el.data('interval') || 6000, 10);

    // El hero no inicializa Slick al cargar: hasta el primer scroll se queda como
    // primer slide estático (el CSS de la sección ya contempla ese estado con
    // :not(.slick-initialized)). Así la carga inicial no clona nodos, no fuerza
    // reflow y no descarga los slides 2..N, que están en display:none.
    let heroInitialized = false;

    function initHeroSlider() {
      if (heroInitialized) return;
      heroInitialized = true;

      $el.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: dots,
        arrows: arrows,
        autoplay: autoplay,
        autoplaySpeed: autoplaySpeed,
        adaptiveHeight: true,
      });

      // Con este disparador el hero suele quedar ya fuera de pantalla al inicializar,
      // así que se pausa el autoplay mientras no se vea: evita rotar y descargar
      // slides que nadie está mirando.
      if (autoplay && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!$el.hasClass('slick-initialized')) return;
            $el.slick(entry.isIntersecting ? 'slickPlay' : 'slickPause');
          });
        }).observe($el[0]);
      }
    }

    window.addEventListener('scroll', initHeroSlider, { passive: true, once: true });

    // Si la página ya viene desplazada (recarga a media página, vuelta atrás, ancla),
    // no habrá evento de scroll: inicializa directamente.
    if (window.scrollY > 0) initHeroSlider();
  });

  // Modulo tabs
  $('.container-product-info-details .nav-item').on('click', function () {
    const index = $(this).index();

    $('.container-product-info-details .nav-item').removeClass('active');
    $('.container-product-info-details .content-info').removeClass('active');

    $(this).addClass('active');
    $('.container-product-info-details .content-info').eq(index).addClass('active');
  });

  // Cerrar content-info del modulo de tabs
  $('.close-content-info').on('click', function () {
    $(this).closest('.content-info').removeClass('active');
  });


  // Cerrar todos los acordeones al abrir uno de la interna del producto
  $('.container-product-info-details .accordion-head').click(function () {
    if ($(this).parent().hasClass("open")) {
      $(this).parent().removeClass("open");
      $(this).siblings(".accordion-body").slideToggle(500);
      $(this).siblings(".accordion-body").find('.accordion-body').slideUp(500);
    } else {
      if ($("body").hasClass("not-hover-supported")) {
        $(this).parents('.container-accordion').find('.accordion-body').slideUp(500);
      }
      $(this).parents('.container-accordion').find('.accordion').removeClass('open')
      $(this).parent().addClass("open");
      $(this).siblings(".accordion-body").slideToggle(500);

      $(this).parent().nextAll().find('.accordion-body').filter(function () {
        return $(this).closest('.accordion.no-accordion-desktop').length === 0;
      }).slideUp(500);
      $(this).parent().prevAll().find('.accordion-body').filter(function () {
        return $(this).closest('.accordion.no-accordion-desktop').length === 0;
      }).slideUp(500);
    }
  });

  //ocultar / mostrar header dependiendo del scroll
  $(function () {
    let lastScrollTop = 0;
    const delta = 10;
    const $header = $('header');
    const $stickyElements = $('.sticky-follow-header'); // 👈 todos los elementos afectados
    const $contentSlider = $('.main-product .content-slider-vendor');


    const $stickyElementsHeader = $(".stores-modal")

    // Establece top inicial
    const headerHeight = $header.outerHeight();
    $contentSlider.css('top', headerHeight + 'px');

    $(window).on('scroll', function () {
      let scrollTop = $(this).scrollTop();
      const headerHeight = $header.outerHeight();

      if (scrollTop < 100) {
        $header.removeClass('hide-header');

        // Todos los elementos con sticky-follow-header se pegan arriba
        $stickyElements.css('top', '0');

        // Slider mantiene desplazamiento inicial
        $contentSlider.css('top', headerHeight + 'px');
        lastScrollTop = scrollTop;
        return;
      }

      if (Math.abs(scrollTop - lastScrollTop) <= delta) {
        return;
      }

      if (scrollTop > lastScrollTop) {
        $header.addClass('hide-header');
        $stickyElements.css('top', '0');
        $contentSlider.css('top', '0');
        $stickyElementsHeader.css('top', headerHeight + 'px');
      } else {
        $header.removeClass('hide-header');
        $stickyElements.css('top', headerHeight + 'px');
        $contentSlider.css('top', headerHeight + 'px');
        $stickyElementsHeader.css('top', '0');
      }

      lastScrollTop = scrollTop;
    });
  });

  // Colocar el icono de check al final de los h5 dentro del acordeon de especificaciones
  $('.find-checks .accordion-body-content h5').after('<p><iconify-icon icon="ei:check"></iconify-icon></p>');

  // Clonación y sincronización del select de ordenación
  $(function () {
    // 1) Creamos o re-creamos el clon y enlazamos la sincronización
    function initClone() {
      // Limpiamos clon previo
      $('#traslatedOrderBy').empty();

      // Localizamos el wrapper original y lo clonamos
      var $origWrap = $('#FacetFiltersSortingTraslation .select').first();
      if (!$origWrap.length) return; // si no existe, salimos
      var $cloneWrap = $origWrap.clone();

      // Preparamos el select clonado
      var $cloneSelect = $cloneWrap
        .find('select')
        .attr('id', 'SortByClone')
        .attr('aria-label', 'Sort products by')
        .appendTo('#traslatedOrderBy');

      // 1.a Cuando el usuario cambie el clon...
      $cloneSelect.on('change', function () {
        var val = this.value;
        var origSelect = document.getElementById('SortBy');
        if (!origSelect) return;

        // — Actualizamos valor en el original
        origSelect.value = val;

        // — Disparamos el evento nativo 'change' (por si hay otros listeners)
        origSelect.dispatchEvent(new Event('change', { bubbles: true }));

        // — Disparamos el evento nativo 'input' en el select para que 
        //   el listener de FacetFiltersForm (que está en el <form>) lo capture
        origSelect.dispatchEvent(new Event('input', { bubbles: true }));
      });

      // 1.b Si el original cambia (por AJAX o por otra parte del script),
      //     actualizamos el clon
      var $origSelect = $('#SortBy');
      $origSelect.off('.syncClone')
        .on('change.syncClone input.syncClone', function () {
          $cloneSelect.val(this.value);
        });
    }

    // Primera clonación al cargar la página
    initClone();

    // 2) Observador: si el AJAX de filtros reescribe el interior de .sorting,
    //    re-clonamos de nuevo
    var sortingDiv = document.getElementById('FacetFiltersSortingTraslation');
    if (sortingDiv) {
      var observer = new MutationObserver(function (muts) {
        for (var m of muts) {
          if (m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)) {
            initClone();
            break;
          }
        }
      });
      observer.observe(sortingDiv, { childList: true, subtree: true });
    }
  });

  // ========================================
  // USER DROPDOWN FUNCTIONALITY
  // ========================================

  // Función para manejar el dropdown del usuario
  function initUserDropdown() {
    const userDropdown = document.querySelector('.content-user .user-dropdown-wrapper');
    const userIcon = document.querySelector('.content-user .user-dropdown-wrapper iconify-icon');
    const dropdownMenu = document.querySelector('.content-user .user-dropdown');

    if (!userDropdown || !dropdownMenu) return;

    let isOpen = false;
    let openedWithKeyboard = false;

    // Obtener todos los enlaces del dropdown (focusables)
    function getMenuItems() {
      return Array.from(dropdownMenu.querySelectorAll('a, button')).filter(el => !el.hasAttribute('disabled'));
    }

    // Función para abrir el dropdown
    function openDropdown() {
      if (isOpen) return;

      isOpen = true;
      userDropdown.classList.add('active');
      dropdownMenu.style.display = 'block';
      userDropdown.setAttribute('aria-expanded', 'true');

      // Animación de entrada
      requestAnimationFrame(() => {
        dropdownMenu.style.opacity = '1';
        dropdownMenu.style.transform = 'translateY(0) scale(1)';
      });

      // A11y: si se abrió con teclado, mover foco al primer enlace
      if (openedWithKeyboard) {
        const items = getMenuItems();
        if (items.length > 0) {
          setTimeout(() => items[0].focus(), 50);
        }
      }

      // Agregar clase al body para prevenir scroll si es necesario
      document.addEventListener('click', closeOnClickOutside);
      document.addEventListener('keydown', closeOnEscape);
      dropdownMenu.addEventListener('keydown', handleMenuKeydown);
    }

    // Función para cerrar el dropdown
    function closeDropdown(restoreFocus = true) {
      if (!isOpen) return;

      isOpen = false;
      userDropdown.classList.remove('active');
      userDropdown.setAttribute('aria-expanded', 'false');

      // Animación de salida
      dropdownMenu.style.opacity = '0';
      dropdownMenu.style.transform = 'translateY(-10px) scale(0.95)';

      setTimeout(() => {
        if (!isOpen) { // Solo ocultar si sigue cerrado
          dropdownMenu.style.display = 'none';
        }
      }, 200);

      // A11y: devolver foco al disparador si se cerró con teclado
      if (restoreFocus && openedWithKeyboard) {
        userDropdown.focus();
      }
      openedWithKeyboard = false;

      // Remover event listeners
      document.removeEventListener('click', closeOnClickOutside);
      document.removeEventListener('keydown', closeOnEscape);
      dropdownMenu.removeEventListener('keydown', handleMenuKeydown);
    }

    // Función para toggle del dropdown
    function toggleDropdown(e) {
      e.preventDefault();
      e.stopPropagation();

      if (isOpen) {
        closeDropdown();
      } else {
        openDropdown();
      }
    }

    // Cerrar al hacer click fuera
    function closeOnClickOutside(e) {
      if (!userDropdown.contains(e.target)) {
        closeDropdown(false);
      }
    }

    // Cerrar con la tecla Escape
    function closeOnEscape(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeDropdown(true);
      }
    }

    // A11y: navegación con teclado dentro del menú
    // - Flechas ↑↓ Home/End: movimiento entre items (extra)
    // - Tab nativo: navega entre links normalmente. Al salir del último (o anterior al primero con Shift+Tab), cierra el dropdown.
    function handleMenuKeydown(e) {
      const items = getMenuItems();
      if (items.length === 0) return;
      const currentIndex = items.indexOf(document.activeElement);

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const next = currentIndex === -1 ? 0 : (currentIndex + 1) % items.length;
        items[next].focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        const prev = currentIndex === -1 ? items.length - 1 : (currentIndex - 1 + items.length) % items.length;
        items[prev].focus();
      } else if (e.key === 'Home') {
        e.preventDefault();
        items[0].focus();
      } else if (e.key === 'Tab' && !e.shiftKey && currentIndex === items.length - 1) {
        // Tab desde el último item: cerrar dropdown y dejar que el foco salga naturalmente
        closeDropdown(false);
      } else if (e.key === 'Tab' && e.shiftKey && currentIndex === 0) {
        // Shift+Tab desde el primer item: cerrar y devolver el foco al disparador
        e.preventDefault();
        closeDropdown(true);
      } else if (e.key === 'End') {
        e.preventDefault();
        items[items.length - 1].focus();
      }
    }

    // Event listeners
    userDropdown.addEventListener('click', (e) => {
      openedWithKeyboard = false;
      toggleDropdown(e);
    });

    // A11y: activar con teclado (Enter o Espacio) cuando recibe foco
    userDropdown.addEventListener('keydown', (e) => {
      if (e.target !== userDropdown) return; // solo si el wrapper tiene el foco, no los links del dropdown
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        openedWithKeyboard = true;
        toggleDropdown(e);
      } else if (e.key === 'ArrowDown' && !isOpen) {
        // Flecha abajo en el botón abre el menú y va al primer item (patrón ARIA menu)
        e.preventDefault();
        openedWithKeyboard = true;
        openDropdown();
      }
    });

    // Prevenir que los clicks dentro del dropdown lo cierren (pero permitir que los links naveguen)
    dropdownMenu.addEventListener('click', (e) => {
      if (e.target.tagName !== 'A') {
        e.stopPropagation();
      }
    });

    // Inicializar estilos del dropdown
    dropdownMenu.style.display = 'none';
    dropdownMenu.style.opacity = '0';
    dropdownMenu.style.transform = 'translateY(-10px) scale(0.95)';
    dropdownMenu.style.transition = 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)';

    // console.log('✅ User dropdown initialized');
  }

  // Inicializar el dropdown del usuario cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUserDropdown);
  } else {
    initUserDropdown();
  }

  // También inicializar cuando jQuery esté listo (por compatibilidad)
  $(document).ready(function () {
    // Pequeño delay para asegurar que el DOM esté completamente renderizado
    setTimeout(initUserDropdown, 100);
  });

  waitForExclusiveSectionsAndInit();
  initExclusiveStoreTags();

  // Exponer función globalmente por si se necesita reinicializar
  window.initUserDropdown = initUserDropdown;

  // Exponer función globalmente por si se necesita reinicializar
  window.initExclusiveStoreTags = initExclusiveStoreTags;



  // Slider productos fullscreen - Zoom
  const container = document.querySelector('.main-product .container-product .container-slider');
  if (!container) return;

  const contentSlider = container.querySelector('.main-product .container-product .content-slider');
  if (!contentSlider) return;

  // Variables para manejar el estado del zoom y movimiento
  let isZooming = false;
  let isDragging = false;
  let startDistance = 0;
  let currentScale = 2; // Coincide con tu CSS scale(2)
  let translateX = 0;
  let translateY = 0;
  let startTouchX = 0;
  let startTouchY = 0;
  let startTranslateX = 0;
  let startTranslateY = 0;

  // Función para detectar si es un dispositivo táctil
  const isTouchDevice = () => {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  };

  // Función para obtener coordenadas del evento (mouse o touch)
  const getEventCoordinates = (e) => {
    if (e.touches && e.touches.length > 0) {
      return {
        clientX: e.touches[0].clientX,
        clientY: e.touches[0].clientY
      };
    }
    return {
      clientX: e.clientX,
      clientY: e.clientY
    };
  };

  // Función para calcular distancia entre dos puntos táctiles
  const getDistance = (touch1, touch2) => {
    const dx = touch1.clientX - touch2.clientX;
    const dy = touch1.clientY - touch2.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  };

  // Función para aplicar transformaciones (respeta tu CSS base)
  const applyTransform = (img) => {
    if (img.classList.contains('zoom-active')) {
      // Combinar el scale del CSS con el translate del JavaScript
      img.style.transform = `translate(${translateX}px, ${translateY}px) scale(${currentScale})`;
      // Quitar transition durante el arrastre para suavidad
      if (isDragging || isZooming) {
        img.style.transition = 'none';
      }
    }
  };

  // Función para resetear posición
  const resetTransform = (img) => {
    currentScale = 2; // Reset al valor por defecto
    translateX = 0;
    translateY = 0;
    // Restaurar transition del CSS
    img.style.transition = '';
    // Limpiar transform inline para que use el CSS
    img.style.transform = '';
    img.style.transformOrigin = '';
  };

  // Función para alternar zoom (respeta tus clases CSS)
  const toggleZoom = (img) => {
    if (img.classList.contains('zoom-active')) {
      img.classList.remove('zoom-active');
      resetTransform(img);
    } else {
      img.classList.add('zoom-active');
      currentScale = 2; // Usa el mismo valor que tu CSS
      translateX = 0;
      translateY = 0;
      // No aplicar transform inicial, dejamos que CSS maneje el scale base
    }
  };

  // Función para limitar el movimiento según los límites de la imagen
  const limitMovement = (img, newX, newY) => {
    const rect = img.getBoundingClientRect();
    const containerRect = img.closest('.content-slider').getBoundingClientRect();

    // Usar currentScale para calcular dimensiones escaladas
    const scaledWidth = rect.width;  // Ya está escalado por CSS
    const scaledHeight = rect.height; // Ya está escalado por CSS

    // Calcular límites máximos de movimiento
    const maxX = Math.max(0, (scaledWidth - containerRect.width) / 2);
    const maxY = Math.max(0, (scaledHeight - containerRect.height) / 2);

    // Limitar el movimiento
    const limitedX = Math.max(-maxX, Math.min(maxX, newX));
    const limitedY = Math.max(-maxY, Math.min(maxY, newY));

    return { x: limitedX, y: limitedY };
  };

  // Event listeners para dispositivos táctiles
  if (isTouchDevice()) {

    // Manejar inicio de toque
    contentSlider.addEventListener('touchstart', function (e) {
      if (!container.classList.contains('fullScreen')) return;

      const img = e.target.closest('.slide-img img');
      if (!img) return;

      if (e.touches.length === 1) {
        const touch = e.touches[0];

        if (img.classList.contains('zoom-active')) {
          // Si está en zoom, preparar para arrastrar
          isDragging = true;
          startTouchX = touch.clientX;
          startTouchY = touch.clientY;
          startTranslateX = translateX;
          startTranslateY = translateY;

          // Quitar transition para arrastre suave
          img.style.transition = 'none';
          e.preventDefault();
        } else {
          // Si no está en zoom, preparar para toggle
          const touchStartTime = Date.now();
          let hasMoved = false;

          const handleTouchMove = () => {
            hasMoved = true;
          };

          const handleTouchEnd = (endEvent) => {
            const touchEndTime = Date.now();
            const touchDuration = touchEndTime - touchStartTime;

            if (touchDuration < 300 && !hasMoved && endEvent.changedTouches) {
              e.preventDefault();
              toggleZoom(img);
            }

            contentSlider.removeEventListener('touchmove', handleTouchMove);
            contentSlider.removeEventListener('touchend', handleTouchEnd);
          };

          contentSlider.addEventListener('touchmove', handleTouchMove);
          contentSlider.addEventListener('touchend', handleTouchEnd);
        }
      } else if (e.touches.length === 2) {
        // Pinch to zoom
        e.preventDefault();
        isZooming = true;
        isDragging = false;
        startDistance = getDistance(e.touches[0], e.touches[1]);

        if (!img.classList.contains('zoom-active')) {
          img.classList.add('zoom-active');
        }

        // Quitar transition para zoom suave
        img.style.transition = 'none';

        // Establecer origen entre los dos dedos
        const centerX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        const centerY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
        const rect = img.getBoundingClientRect();
        const x = ((centerX - rect.left) / rect.width) * 100;
        const y = ((centerY - rect.top) / rect.height) * 100;

        img.style.transformOrigin = `${x}% ${y}%`;
      }
    });

    // Manejar movimiento
    contentSlider.addEventListener('touchmove', function (e) {
      if (!container.classList.contains('fullScreen')) return;

      const img = e.target.closest('.slide-img img');
      if (!img) return;

      if (e.touches.length === 1 && isDragging && img.classList.contains('zoom-active')) {
        // Arrastrar imagen con zoom
        e.preventDefault();

        const touch = e.touches[0];
        const deltaX = touch.clientX - startTouchX;
        const deltaY = touch.clientY - startTouchY;

        const newX = startTranslateX + deltaX;
        const newY = startTranslateY + deltaY;

        const limited = limitMovement(img, newX, newY);
        translateX = limited.x;
        translateY = limited.y;

        applyTransform(img);

      } else if (e.touches.length === 2 && isZooming) {
        // Pinch zoom
        e.preventDefault();

        const currentDistance = getDistance(e.touches[0], e.touches[1]);
        const scale = currentDistance / startDistance;
        const newScale = Math.min(Math.max(scale * 2, 1), 4); // Base scale 2 desde CSS

        // Si cambiamos la escala significativamente
        if (Math.abs(currentScale - newScale) > 0.1) {
          const scaleRatio = newScale / currentScale;
          translateX *= scaleRatio;
          translateY *= scaleRatio;

          // Limitar movimiento con nueva escala
          const limited = limitMovement(img, translateX, translateY);
          translateX = limited.x;
          translateY = limited.y;

          currentScale = newScale;
          applyTransform(img);
        }
      }
    });

    // Manejar fin de toque
    contentSlider.addEventListener('touchend', function (e) {
      const img = e.target.closest('.slide-img img');

      if (isZooming) {
        isZooming = false;

        if (img) {
          // Restaurar transition
          img.style.transition = 'transform 0.2s ease';

          // Si la escala es muy pequeña, quitar el zoom
          if (currentScale < 1.5) {
            img.classList.remove('zoom-active');
            resetTransform(img);
          }
        }
      }

      if (isDragging) {
        isDragging = false;

        if (img) {
          // Restaurar transition
          img.style.transition = 'transform 0.2s ease';
        }
      }
    });

    // Prevenir comportamientos por defecto
    contentSlider.addEventListener('touchstart', function (e) {
      const img = e.target.closest('.slide-img img');
      if (img && container.classList.contains('fullScreen')) {
        // Solo prevenir si es fullscreen para no interferir con scroll normal
        if (img.classList.contains('zoom-active') || e.touches.length > 1) {
          e.preventDefault();
        }
      }
    }, { passive: false });

  } else {
    // Event listeners para dispositivos con mouse

    let mouseDown = false;
    let mouseStartX = 0;
    let mouseStartY = 0;

    // Click para toggle zoom
    contentSlider.addEventListener('mousedown', function (e) {
      if (!container.classList.contains('fullScreen')) return;

      const img = e.target.closest('.slide-img img');
      if (!img) return;

      if (img.classList.contains('zoom-active')) {
        // Si está en zoom, preparar para arrastrar
        mouseDown = true;
        mouseStartX = e.clientX;
        mouseStartY = e.clientY;
        startTranslateX = translateX;
        startTranslateY = translateY;

        img.style.cursor = 'grabbing';
        img.style.transition = 'none';
        e.preventDefault();
      } else {
        mouseStartX = e.clientX;
        mouseStartY = e.clientY;
      }
    });

    contentSlider.addEventListener('mouseup', function (e) {
      const img = e.target.closest('.slide-img img');

      if (mouseDown) {
        mouseDown = false;
        if (img) {
          img.style.cursor = 'zoom-out';
          img.style.transition = 'transform 0.2s ease';
        }
      } else if (img) {
        // Solo hacer toggle si no fue un arrastre
        const moveDistance = Math.abs(e.clientX - mouseStartX) + Math.abs(e.clientY - mouseStartY);
        if (moveDistance < 5) {
          toggleZoom(img);
        }
      }
    });

    contentSlider.addEventListener('mousemove', function (e) {
      if (!container.classList.contains('fullScreen')) return;

      const img = e.target.closest('.slide-img img');
      if (!img) return;

      if (mouseDown && img.classList.contains('zoom-active')) {
        // Arrastrar con mouse
        const deltaX = e.clientX - mouseStartX;
        const deltaY = e.clientY - mouseStartY;

        const newX = startTranslateX + deltaX;
        const newY = startTranslateY + deltaY;

        const limited = limitMovement(img, newX, newY);
        translateX = limited.x;
        translateY = limited.y;

        applyTransform(img);
      } else if (img.classList.contains('zoom-active') && !mouseDown) {
        // Seguir mouse para punto focal (solo si no está arrastrando)
        const rect = img.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;

        img.style.transformOrigin = `${x}% ${y}%`;
      }
    });

    // Resetear origen al salir
    contentSlider.addEventListener('mouseleave', function () {
      const imgs = contentSlider.querySelectorAll('.zoom-active');
      imgs.forEach(img => {
        img.style.transformOrigin = 'center center';
        if (!mouseDown) {
          img.style.cursor = 'zoom-out';
        }
      });

      if (mouseDown) {
        mouseDown = false;
      }
    });

    // Manejar wheel para zoom (opcional)
    contentSlider.addEventListener('wheel', function (e) {
      if (!container.classList.contains('fullScreen')) return;

      const img = e.target.closest('.slide-img img');
      if (!img || !img.classList.contains('zoom-active')) return;

      e.preventDefault();

      const delta = e.deltaY > 0 ? 0.9 : 1.1;
      const newScale = Math.min(Math.max(currentScale * delta, 1), 4);

      if (Math.abs(newScale - currentScale) > 0.1) {
        const scaleRatio = newScale / currentScale;
        translateX *= scaleRatio;
        translateY *= scaleRatio;

        const limited = limitMovement(img, translateX, translateY);
        translateX = limited.x;
        translateY = limited.y;

        currentScale = newScale;
        img.style.transition = 'none';
        applyTransform(img);

        // Restaurar transition después de un delay
        setTimeout(() => {
          img.style.transition = 'transform 0.2s ease';
        }, 50);
      }
    });
  }

  // Función para resetear todo al salir de fullScreen
  const resetAllZoom = () => {
    const imgs = contentSlider.querySelectorAll('.zoom-active');
    imgs.forEach(img => {
      img.classList.remove('zoom-active');
      resetTransform(img);
    });

    // Resetear todas las variables de estado
    isZooming = false;
    isDragging = false;
    currentScale = 2;
    translateX = 0;
    translateY = 0;
    startTouchX = 0;
    startTouchY = 0;
    startTranslateX = 0;
    startTranslateY = 0;
  };

  // Observer para detectar cuando se quita la clase fullScreen
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        // Si ya no tiene la clase fullScreen, resetear todo
        if (!container.classList.contains('fullScreen')) {
          resetAllZoom();
        }
      }
    });
  });

  // Observar cambios en la clase del container
  observer.observe(container, {
    attributes: true,
    attributeFilter: ['class']
  });

  // Event listener común - Escape key
  if (!isTouchDevice()) {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        resetAllZoom();
      }
    });
  }

});

(function ($) {
  const breakpoint = 1023;
  const menuSelector =
    'header .content-company-menu-container-bottom';

  function createCustomScrollbar() {
    const $menu = $(menuSelector).first();

    if (!$menu.length) return;

    // Evitar inicialización duplicada
    if ($menu.parent().hasClass('custom-menu-scroll-wrapper')) {
      updateCustomScrollbar($menu);
      return;
    }

    $menu.wrap('<div class="custom-menu-scroll-wrapper"></div>');

    const $wrapper = $menu.parent();

    $wrapper.append(`
      <div class="custom-menu-scroll-track">
        <div class="custom-menu-scroll-thumb"></div>
      </div>
    `);

    $menu.on(
      'scroll.customMenuScrollbar',
      function () {
        updateCustomScrollbar($(this));
      }
    );

    updateCustomScrollbar($menu);
  }

  function updateCustomScrollbar($menu) {
    const menu = $menu.get(0);
    const $wrapper = $menu.parent(
      '.custom-menu-scroll-wrapper'
    );
    const $track = $wrapper.find(
      '.custom-menu-scroll-track'
    );
    const $thumb = $wrapper.find(
      '.custom-menu-scroll-thumb'
    );

    if (!menu || !$track.length || !$thumb.length) return;

    const visibleHeight = menu.clientHeight;
    const totalHeight = menu.scrollHeight;

    if (totalHeight <= visibleHeight) {
      $track.hide();
      return;
    }

    $track.show();

    const trackHeight = $track.innerHeight();

    const thumbHeight = Math.max(
      (visibleHeight / totalHeight) * trackHeight,
      22
    );

    const maxScroll = totalHeight - visibleHeight;
    const maxThumbPosition = trackHeight - thumbHeight;

    const thumbPosition =
      maxScroll > 0
        ? (menu.scrollTop / maxScroll) *
        maxThumbPosition
        : 0;

    $thumb.css({
      height: `${thumbHeight}px`,
      transform: `translateY(${thumbPosition}px)`
    });
  }

  function removeCustomScrollbar() {
    const $wrapper = $(
      'header .custom-menu-scroll-wrapper'
    );

    if (!$wrapper.length) return;

    const $menu = $wrapper.find(
      '.content-company-menu-container-bottom'
    );

    $menu.off('.customMenuScrollbar');
    $menu.insertBefore($wrapper);
    $wrapper.remove();
  }

  function handleCustomScrollbar() {
    if (window.matchMedia(`(max-width: ${breakpoint}px)`).matches) {
      createCustomScrollbar();
    } else {
      removeCustomScrollbar();
    }
  }

  $(document).ready(handleCustomScrollbar);

  $(window).on(
    'resize.customMenuScrollbar orientationchange.customMenuScrollbar',
    handleCustomScrollbar
  );
})(jQuery);

// Función para truncar HTML preservando la estructura original exacta
function truncateHTML(element, maxWords) {
  const $element = $(element);
  const fullHTML = $element.html();

  // Obtener texto plano para contar palabras totales
  const textContent = $element.text().trim();
  const totalWords = textContent.split(/\s+/).filter(w => w.length > 0);

  // Si no hay suficientes palabras, no hacer nada
  if (totalWords.length <= maxWords) {
    return { needsTruncate: false, shortHTML: fullHTML, fullHTML: fullHTML };
  }

  // Clonar el elemento original para preservar exactamente el HTML
  const clone = $element.clone()[0];

  let wordCount = 0;
  let shouldStop = false;

  // Función que cuenta palabras y elimina nodos después del límite
  function processNode(node) {
    if (shouldStop) {
      return 'remove'; // Marcar para eliminar
    }

    // Nodo de texto: contar palabras
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent;
      const words = text.match(/\S+/g) || []; // Extraer palabras sin modificar espacios

      if (words.length === 0) {
        return 'keep'; // Mantener espacios en blanco
      }

      const wordsAvailable = maxWords - wordCount;

      if (words.length <= wordsAvailable) {
        // Todas las palabras caben, mantener el nodo intacto
        wordCount += words.length;
        return 'keep';
      } else {
        // Necesitamos truncar dentro de este nodo
        // Encontrar la posición exacta donde cortar
        let remainingWords = wordsAvailable;
        let cutPosition = 0;
        let currentPos = 0;

        for (let i = 0; i < words.length && i < wordsAvailable; i++) {
          const wordIndex = text.indexOf(words[i], currentPos);
          cutPosition = wordIndex + words[i].length;
          currentPos = cutPosition;
        }

        // Truncar el texto en la posición exacta y agregar "..."
        node.textContent = text.substring(0, cutPosition) + '...';
        wordCount = maxWords;
        shouldStop = true;
        return 'keep';
      }
    }

    // Nodo elemento: procesar hijos
    if (node.nodeType === Node.ELEMENT_NODE) {
      const children = Array.from(node.childNodes);
      const toRemove = [];

      for (let child of children) {
        const result = processNode(child);
        if (result === 'remove') {
          toRemove.push(child);
        }
      }

      // Eliminar nodos marcados
      toRemove.forEach(child => node.removeChild(child));

      // Mantener el elemento si tiene contenido
      return node.childNodes.length > 0 ? 'keep' : 'remove';
    }

    return 'keep';
  }

  // Procesar el clon
  const children = Array.from(clone.childNodes);
  const toRemove = [];

  for (let child of children) {
    const result = processNode(child);
    if (result === 'remove') {
      toRemove.push(child);
    }
  }

  toRemove.forEach(child => clone.removeChild(child));

  const truncatedHTML = clone.innerHTML;

  return { needsTruncate: true, shortHTML: truncatedHTML, fullHTML: fullHTML };
}

// Inicializar truncado de descripciones al cargar la página
$(document).ready(function () {
  $('.product-description[data-truncate-words]').each(function () {
    const maxWords = parseInt($(this).data('truncate-words')) || 18;
    const result = truncateHTML(this, maxWords);

    if (result.needsTruncate) {
      // Crear estructura con versión corta y completa
      const $container = $('<div class="product-description-container"></div>');
      const $short = $('<div class="product-description product-description--short"></div>').html(result.shortHTML);
      const $full = $('<div class="product-description product-description--full hidden"></div>').html(result.fullHTML);

      $container.append($short).append($full);
      $(this).replaceWith($container);

      // Mostrar el botón "View details"
      $('.product-view-details-link').show();
    } else {
      // No hay suficiente contenido para truncar, ocultar botón
      $('.product-view-details-link').hide();
    }
  });
});

// Details Modal Main product template
$(document).on('click', '.product-view-details-link', function (e) {
  // Prevenir comportamiento por defecto
  e.preventDefault();

  // Buscar elementos de forma segura y específica
  const $fullDescription = $('.product-description--full');
  const $shortDescription = $('.product-description--short');

  // Validar que ambos elementos existen antes de manipular
  if ($fullDescription.length > 0 && $shortDescription.length > 0) {
    // Toggle de clases de forma segura
    $fullDescription.toggleClass('hidden');
    $shortDescription.toggleClass('hidden');

    // Actualizar texto del enlace basado en el estado actual
    const isFullHidden = $fullDescription.hasClass('hidden');
    $(this).text(isFullHidden ? 'View details' : 'Hide details');
  }
});

// hover to .cth .tab
$(document).on('mouseenter', '.cth .tab', function () {
  $(this).addClass('active');
}).on('mouseleave', '.cth .tab', function () {
  if (!$(this).hasClass('alltab')) {
    $(this).removeClass('active');
  }
});


function isMobileDevice() {
  return window.innerWidth <= 768 || /Mobi|Android/i.test(navigator.userAgent);
}

$(document).ready(function () {

  // Si no es mobile activar el primer tab y content-info
  if (!isMobileDevice()) {
    $('.container-tabs-product .content-nav .nav-item').first().addClass('active');
    $('.container-tabs-product .content-info').first().addClass('active');
  }

});

// Global listener for "OPEN CHAT" buttons to trigger Tidio
document.body.addEventListener('click', function (e) {
  const target = e.target.closest('a, button, .btn, [class*="btn"]');
  if (target && target.textContent.trim().toUpperCase().includes('OPEN CHAT')) {
    e.preventDefault();
    e.stopPropagation();
    if (window.tidioChatApi) {
      window.tidioChatApi.open();
    }
  }
}, true);


(function () {
  // El widget de Synchrony expone su API en window.syfMPP (UniFi.js).
  // openMPPOfferModal abre el mismo modal que el enlace "Learn how" del widget.
  function financeAmount() {
    // #product-content es el div oculto del app block: es la fuente que usa el
    // propio widget, asi que sigue el precio de la variante seleccionada.
    var priceEl = document.getElementById('product-content');
    var raw = (priceEl && priceEl.textContent) || window.syfPdpPrice || '';
    return raw.replace(/[^\d.]/g, '');
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.open-synchrony')) return;
    e.preventDefault();

    var amount = financeAmount();
    if (!amount || !window.syfMPP || typeof window.syfMPP.openMPPOfferModal !== 'function') return;

    // OJO: UniFi.js lee `partnerId`, mientras que syfWidgetObject lo publica
    // como `syfPartnerId`. Si no se mapea, el modal abre pero la peticion falla.
    var cfg = window.syfWidgetObject || {};
    window.syfMPP.openMPPOfferModal(
      Object.assign({}, cfg, {
        partnerId: cfg.partnerId || cfg.syfPartnerId,
        amount: amount
      })
    );
  });
})();


(function () {
  const PHONE_DIGITS = '8883509045';
  const PHONE_PATTERN =
    /(?:\+?1[\s.\-]*)?(?:\(888\)|888)[\s.\-]*350[\s.\-]*9045|\b8883509045\b/g;

  function toDigits(value) {
    const digits = value.replace(/\D/g, '');
    return digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  }

  function wrapPhoneTextNode(textNode) {
    const parent = textNode.parentElement;
    if (!parent || parent.closest('a, script, style, noscript, textarea')) return;

    const text = textNode.nodeValue;
    PHONE_PATTERN.lastIndex = 0;
    if (!PHONE_PATTERN.test(text)) return;
    PHONE_PATTERN.lastIndex = 0;

    const fragment = document.createDocumentFragment();
    let lastIndex = 0;
    let match;

    while ((match = PHONE_PATTERN.exec(text)) !== null) {
      if (toDigits(match[0]) !== PHONE_DIGITS) continue;

      fragment.append(text.slice(lastIndex, match.index));
      const link = document.createElement('a');
      link.href = 'tel:+1' + PHONE_DIGITS;
      link.textContent = match[0];
      fragment.append(link);
      lastIndex = PHONE_PATTERN.lastIndex;
    }

    if (!lastIndex) return;
    fragment.append(text.slice(lastIndex));
    parent.replaceChild(fragment, textNode);
  }

  function linkifyPhones(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach(wrapPhoneTextNode);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => linkifyPhones(document.body));
  } else {
    linkifyPhones(document.body);
  }
})();